import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../../utills/utils";

import Category from "./Category";
import Modal from "../../Modals/ProductModal";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;
const Header = styled.div`
  width: 100%;
  height: 10%;
`;
const AllCategory = styled.div`
  width: 103%;
  height: 85%;
  display: flex;
  margin-top: 2%;
  overflow-y: scroll;
`;
const HeaderTitle = styled.h2`
  float: left;
  width: 60%;
  margin: 0;
  padding: 0;
`;
const AddButton = styled.button`
  float: right;
  padding: 12px 30px;
  font-size: 15px;
  border: 1px solid #eee;
  cursor: pointer;
  background: white;
`;
const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
`;
const AddTitele = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  font-weight: 500;
  color: #f97a7a;
`;
const SubTitle = styled.h4`
  margin: 20px 0 10px 0;
  padding: 0;
  font-size: 1em;
  font-weight: 500;
  color: #f97a7a;
`;
const Button = styled.button`
  width: 100%;
  padding: 13px 10px;
  background: #f97a7a;
  color: white;
  font-size: 1.1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px 0;
`;
function Categories() {
  const [addModal, setAddModal] = useState(false);
  const [name, setName] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCats, setSubs] = useState([]);
  const [subInput, setSubInput] = useState("");

  const subAddhandler = () => {
    const subs = subCats;
    subs.push("nice");
    setSubs(subs);
  };
  const addModalHandler = () => {
    setAddModal(!addModal);
  };

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };

  const fetchCategories = async () => {
    const categories = await axios.post(server, {
      query: `
             query{
              allCategories{
                _id
                name
                subCategories{
                  _id
                  name
                }
              }
             }
           `,
    });
    console.log(categories);
    setCategories(categories.data.data.allCategories);
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  const addCategoryHandler = async () => {
    try {
      if (!name) {
        const categories = await axios.post(server, {
          query: `
                       query{
                        allCategories{
                           _id
                           name 
                        }
                       }
                    `,
        });
      }
    } catch (error) {
      throw error;
    }
  };
 let subcats =  subCats.map((sub) => {
   <input placeholder="name" value={sub} />;
 })
  return (
    <Container>
      <Modal show={addModal} closeModal={addModalHandler}>
        <div style={{ padding: "2%" }}>
          <AddTitele>Add category</AddTitele>
          <form onSubmit={addCategoryHandler}>
            <Input
              value={name}
              onChange={nameChangeHandler}
              required="true"
              type="text"
              placeholder="Category name"
            />
            <SubTitle>Sub categories</SubTitle>
            {
             subcats
            }
            <input placeholder="name" />
            <button type="button" onClick={subAddhandler}>Add</button>

            <Button type="submit">Add</Button>
          </form>
        </div>
      </Modal>
      <Header>
        <HeaderTitle>Categories</HeaderTitle>
        <AddButton onClick={addModalHandler}>Add category</AddButton>
      </Header>
      <AllCategory>
        {categories.map((cat, id) => {
          return <Category category={cat} key={cat._id} />;
        })}
      </AllCategory>
    </Container>
  );
}

export default Categories;
